import { useQuery } from 'react-query';
import { getUser, getUserProfile } from '../apis/auth';
import { UIUser } from '../../../../packages/types/src/user';

export function useUser() {
  
  return useQuery({
    queryKey: 'getUser',
    queryFn: async () => (await getUser()).data.user as UIUser,
    staleTime: 60000,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: true,
  })
}

export function useUserProfile() {
  
  return useQuery({
    queryKey: 'getUserProfile',
    queryFn: async () => (await getUserProfile()).data.userProfile,
    staleTime: 60000,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: true,
  })
}




